module.exports = "<email-multiselect [value]=\"value\"\n                   [disabled]=\"disabled\"\n                   [loading]=\"isLoading\"\n                   [autocomplete]=\"autocomplete$\"\n                   [autocompleteValues]=\"autocompleteValues\"\n                   [placeholder]=\"placeholder\"\n                   [customClass]=\"'email-multiselect'\"\n                   [maxAllowedAmount]=\"5\"\n                   (valueChanges)=\"valueChanges($event)\">\n</email-multiselect>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/email-field/email-field.component.html
// module id = ./web/modern/components/common/email-field/email-field.component.html
// module chunks = 0